
import { Badge } from "@/components/ui/badge";

interface ArticleHeaderProps {
  title: string;
  readTime?: string;
  category?: string;
  isPreviewMode?: boolean;
}

const ArticleHeader = ({
  title,
  readTime,
  category,
  isPreviewMode = false,
}: ArticleHeaderProps) => {
  return (
    <div className="mb-6">
      <h1 className="text-3xl md:text-4xl font-bold mb-4">{title}</h1>
      
      <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
        {isPreviewMode && (
          <Badge variant="secondary" className="bg-amber-100 text-amber-800 hover:bg-amber-200">
            Preview Mode
          </Badge>
        )}
      </div>
    </div>
  );
};

export default ArticleHeader;
